import { Fade, IconButton, Modal, Typography, Box } from "@mui/material";
import React from "react";
import CancelIcon from "../../icons/Cancel";
import LogoImage from "../../../assets/ByteChip.png";

const CustomModal = ({
  children,
  openModal,
  handleClose,
  title,
  defaultLogoImage = true,
}: {
  children: any;
  openModal: boolean;
  handleClose: () => void;
  title?: string;
  defaultLogoImage?: boolean;
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    p: 4,
  };
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      // slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={style}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 2,
              top: 1,
            }}
          >
            <CancelIcon color="primary" />
          </IconButton>
          {defaultLogoImage && (
            <img
              src={LogoImage}
              style={{
                position: "absolute",
                top: -40,
                left: "40%",
              }}
            />
          )}
          {title && (
            <Typography
              variant="h4"
              sx={{
                fontSize: "32px",
                textAlign: "center",
                mt: 2,
                fontWeight: 700,
              }}
            >
              {title}
            </Typography>
          )}
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
